<template>
  <div class="d-flex gap-1" :class="inline ? 'align-center' : ''">
    <v-btn
      v-if="inline"
      :class="{ 'white-button': !flat }"
      :icon="flat"
      x-small
      @click="onUpdate('onMinus', -decrementValue)"
    >
      <v-icon size="13px"> mdi-minus </v-icon>
    </v-btn>
    <v-text-field
      v-model.number="plusMinusValue"
      name="units"
      type="number"
      dense
      hide-details
      :min="min"
      :max="max"
    />
    <div class="d-flex flex-column gap-1">
      <v-btn
        :class="{ 'red-button': !flat }"
        :icon="flat"
        x-small
        @click="onUpdate('onPlus', incrementValue)"
      >
        <v-icon size="13px"> mdi-plus </v-icon>
      </v-btn>
      <v-btn
        v-if="!inline"
        :class="{ 'white-button': !flat }"
        :icon="flat"
        x-small
        @click="onUpdate('onMinus', -decrementValue)"
      >
        <v-icon size="13px"> mdi-minus </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  export default {
    name: 'PlusMinusInput',

    props: {
      value: {
        type: [Number],
        required: false,
      },

      min: {
        type: Number,
        default: 1,
      },

      max: {
        type: Number,
        default: null,
      },

      incrementValue: {
        type: Number,
        default: 1,
      },

      decrementValue: {
        type: Number,
        default: 1,
      },

      flat: {
        type: Boolean,
        default: true,
      },

      inline: Boolean,
    },

    computed: {
      plusMinusValue: {
        set(newValue) {
          if (this.canUpdate(newValue))
            this.$emit(
              'input',
              newValue !== '' && newValue !== 0 ? newValue : null
            );
          else this.$emit('input', this.min);
        },

        get() {
          return this.value;
        },
      },
    },

    methods: {
      onUpdate(event, value) {
        const total = parseInt(this.plusMinusValue || 0) + value;

        if (this.canUpdate(total)) {
          this.plusMinusValue = total;
          this.$emit(event);
        }
      },

      canUpdate(newValue) {
        let newVal = parseInt(newValue) || 0;

        if (this.min !== null && newVal < this.min) return false;
        else if (this.max !== null && newVal > this.max) return false;

        return true;
      },
    },
  };
</script>
<style scoped>
  /* Removes + - buttons in numeric inputs */
  ::v-deep .v-text-field__slot > input[type='number'] {
    -moz-appearance: textfield;
    appearance: textfield;
  }

  ::v-deep .v-text-field__slot > input::-webkit-outer-spin-button,
  ::v-deep .v-text-field__slot > input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>
